import { useContext } from "react";
import { StoreContext } from "@roc/feature-app-core";
import { AddAppraisalStore } from "./addAppraisalStore";

export const useAddAppraisalStore = () =>
  useContext<{
    addAppraisalStore: AddAppraisalStore;
  }>(StoreContext);
